import type { Auth0DecodedHash } from "auth0-js";

import { initializeAnalytics } from "./common/tracking/trackerService";
import { maybeSha256 } from "./common/utils/hash";

export const initializeAnalyticsAfterAuth = async (
  r: Auth0DecodedHash | undefined,
) => {
  const userId = r?.idTokenPayload.sub as string | undefined;
  const hashedUserId = userId != null ? await maybeSha256(userId) : undefined;
  initializeAnalytics(hashedUserId);
};
